module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/1-8e4977bbde0555ee2f73becbbd8d5132.jpg";